import React from 'react';

import { Card, CardContent } from 'shadcn/components/ui/Card';
import { cn } from 'shadcn/lib/utils';

import { formatReceivedSummary } from './printLabelsUtils';

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string | number} props.sku
 * @param {string} props.itemName
 * @param {number} props.totalCases
 * @param {number} props.numPallets
 * @param {number | null} [props.unitsPerCase]
 */
function PrintAllocatedLabelsSummaryCard({ className, itemName, numPallets, sku, totalCases, unitsPerCase = null }) {
    const receivedSummary = formatReceivedSummary({ totalCases, numPallets, unitsPerCase });

    return (
        <Card className={cn('gap-2 py-4 shadow-sm', className)}>
            <CardContent className="flex flex-col gap-1 px-4">
                <p className="text-xs font-medium tracking-wide text-muted-foreground uppercase">SKU {sku}</p>
                <p className="text-base font-semibold">{itemName}</p>
                <p className="text-sm text-muted-foreground">{receivedSummary}</p>
            </CardContent>
        </Card>
    );
}

export { PrintAllocatedLabelsSummaryCard };
